import { usePageContext } from '../../../../context.js';
import { useTaskContext } from '../../context.js';
import { wrapper } from './_freetext.style.js';
import { RichtextInput } from './input.richtext.js';
import { RichtextReadonly } from './readonly.richtext.js';
import { jsx } from 'react/jsx-runtime';

function FreeTextTask(props) {
  const pageContext = usePageContext();
  const context = useTaskContext();
  return /*#__PURE__*/jsx("div", {
    className: wrapper,
    "data-context": context,
    "data-page-context": pageContext,
    children: pageContext !== "print" && context === "input" ? /*#__PURE__*/jsx(RichtextInput, {
      ...props
    }) : /*#__PURE__*/jsx(RichtextReadonly, {
      ...props
    })
  });
}

export { FreeTextTask };
//# sourceMappingURL=_freetext.js.map
